import { useLanguage } from '../contexts/LanguageContext'
import { HomeMobileAccordion } from './HomeMobileAccordion'

const ITEM_KEYS = [
  'trustBadges.legallyBinding',
  'trustBadges.esignUeta',
  'trustBadges.eidas',
  'trustBadges.encryptedStorage',
  'trustBadges.auditTrail',
  'trustBadges.tamperProof',
]

function TrustCheckIcon() {
  return (
    <svg className="trust-badges__check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

/**
 * Reusable compliance / trust bullet list for marketing pages.
 * @param {{ className?: string, id?: string, compact?: boolean, variant?: 'default' | 'home' }} props
 */
export function TrustBadges({ className = '', id, compact = false, variant = 'default' }) {
  const { t } = useLanguage()
  const headingId = id ? `${id}-heading` : undefined
  const HeadingTag = compact ? 'p' : 'h2'
  const titleKey = variant === 'home' ? 'trustBadges.homeTitle' : 'trustBadges.heading'
  const list = (
    <ul className="trust-badges__list">
      {ITEM_KEYS.map((key) => (
        <li key={key} className="trust-badges__item">
          <span className="trust-badges__icon-wrap" aria-hidden>
            <TrustCheckIcon />
          </span>
          <span className="trust-badges__text">{t(key)}</span>
        </li>
      ))}
    </ul>
  )
  return (
    <section
      className={`trust-badges${compact ? ' trust-badges--compact' : ''}${variant === 'home' ? ' trust-badges--variant-home' : ''} ${className}`.trim()}
      aria-labelledby={headingId}
      id={id}
    >
      {variant === 'home' ? <div className="trust-badges__home-ambient" aria-hidden /> : null}
      <div className={`trust-badges__inner${variant === 'home' ? ' trust-badges__inner--home-glass' : ''}`}>
        {variant === 'home' ? (
          <p className="trust-badges__home-eyebrow">{t('trustBadges.homeEyebrow')}</p>
        ) : null}
        {variant === 'home' ? (
          <HeadingTag
            className="trust-badges__heading trust-badges__heading--home"
            id={headingId}
          >
            {t(titleKey)}
          </HeadingTag>
        ) : (
          <HomeMobileAccordion
            className="trust-badges-acc"
            summary={
              <HeadingTag
                className={`trust-badges__heading${compact ? ' trust-badges__heading--compact' : ''}`}
                id={headingId}
              >
                {t(titleKey)}
              </HeadingTag>
            }
          >
            {list}
          </HomeMobileAccordion>
        )}
        {variant === 'home' ? (
          <>
            {list}
            <p className="trust-badges__home-subline">{t('trustBadges.homeSubline')}</p>
          </>
        ) : null}
      </div>
    </section>
  )
}
